import { AsyncThunkPayloadCreator, createAsyncThunk } from '@reduxjs/toolkit';
import { AppThunkApiConfig } from '../store';

export const createAsyncAppThunk = <TRequest, TResult, TProject = unknown>(
    typePrefix: string,
    payloadCreator: AsyncThunkPayloadCreator<TResult, TRequest, AppThunkApiConfig<TProject>>
) => {
    return createAsyncThunk(typePrefix, payloadCreator);
};